import React from "react";
import { Space } from "@masterteam/mt-design-react";
import WhitLogo from "../../../../assets/images/login-page-logo.svg";

import styles from "./LoginForm.module.scss";
import useIsAr from "../../../../Hooks/useIsAr";
import { FormattedMessage } from "react-intl";

function Header() {
  const [isAr] = useIsAr();

  return (
    <Space
      direction="vertical"
      align="center"
      gap={40}
      className={styles.header}
    >
      <Space direction="vertical" align="center" gap={60}>
        <img
          alt="logo"
          src={WhitLogo}
          style={{
            maxWidth: window.env.BIG_LOGO ? "50%" : "320px",
          }}
        />
        <Space direction="vertical" align="center" gap={12}>
          <h3>
            <FormattedMessage id="login-page.welcome-to-msar" />
          </h3>
          <p>
            <FormattedMessage id="login-page.for-strategic-performance" />
          </p>
        </Space>
      </Space>
    </Space>
  );
}

export default Header;
